"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mxp_schemas_1 = require("mxp-schemas");
exports.default = (attributes) => {
    var _a, _b;
    if (!attributes) {
        return {
            isPhProduct: false,
            isBasicPhProduct: false,
            isPhSubscriptionProduct: false,
        };
    }
    const physicalProductAvailableFormats = [
        mxp_schemas_1.Product.AvailableFormat.TEXT,
        mxp_schemas_1.Product.AvailableFormat.HARDCOVER,
        mxp_schemas_1.Product.AvailableFormat.PAPERBACK,
    ];
    const physicalSubscriptionsProductTypes = [
        mxp_schemas_1.Product.SubscriptionProductType.COURSE,
        mxp_schemas_1.Product.SubscriptionProductType.PUBLICATION,
    ];
    // sendLineItemsToProvisioningQueues - splitByProvider - lineItem has Array of attributes
    if (Array.isArray(attributes)) {
        const { isPhysicalProductInArray, isSubscriptionProductInArray, showQuantityInArray } = attributes.reduce((acc, attr) => {
            if (attr.name === 'productType' && physicalProductAvailableFormats.includes(attr.value.key)) {
                acc.isPhysicalProductInArray = true;
            }
            if (attr.name === 'subscriptionProductType' && physicalSubscriptionsProductTypes.includes(attr.value.key)) {
                acc.isSubscriptionProductInArray = true;
            }
            if (attr.name === 'showQuantity' && attr.value) {
                acc.showQuantityInArray = true;
            }
            return acc;
        }, { isPhysicalProductInArray: false, isSubscriptionProductInArray: false, showQuantityInArray: false });
        return {
            isPhProduct: isPhysicalProductInArray || (isSubscriptionProductInArray && showQuantityInArray),
            isBasicPhProduct: isPhysicalProductInArray,
            isPhSubscriptionProduct: isSubscriptionProductInArray && showQuantityInArray,
        };
    }
    const productAvailableFormat = (_a = attributes.productType) === null || _a === void 0 ? void 0 : _a.key;
    const subscriptionProductTypeKey = (_b = attributes.subscriptionProductType) === null || _b === void 0 ? void 0 : _b.key;
    const showQuantity = attributes.showQuantity;
    const isPhysicalProduct = physicalProductAvailableFormats.includes(productAvailableFormat);
    const isSubscriptionProduct = physicalSubscriptionsProductTypes.includes(subscriptionProductTypeKey);
    return {
        isPhProduct: isPhysicalProduct || (isSubscriptionProduct && showQuantity),
        isBasicPhProduct: isPhysicalProduct,
        isPhSubscriptionProduct: isSubscriptionProduct && showQuantity,
    };
};
//# sourceMappingURL=isPhysicalProduct.js.map